import {
    getServerTexts as getTexts,
    initTexts,
    texts as localization
} from '../../Localization/texts';

export const entity = 'UI_EMAILEDITOR';

export const en = {
    // title
    email_editor: 'Email Editor',

    // dynamic button
    add_dynamic_value_title: 'Add Dynamic Value',
    add_dynamic_value_tooltip: 'Add a dynamic value',
    rule_number: 'Rule number',
    rule_description: 'Rule description',
    tree_dropdown_label: 'Dynamic Value Field',
    tree_dropdown_placeholder: 'Choose a field',
    tree_dropdown_search_placeholder: 'Search for form',
    choose_dropdown_label: 'Field for Dynamic Values',
    choose_dropdown_placeholder: 'Select field…',
    choose_dropdown_search_placeholder: 'Search for field',

    // image button
    add_an_image: 'Add an image',
    image_title: 'Add Images',
    drag_and_drop: 'You can drag and drop an image directly into the email, or select an image.',
    select_file: 'Add file',

    // hyperlink button
    add_hyperlink_tooltip: 'Add a link',
    add_hyperlink_title: 'Add link',
    display_text: 'Text to display',
    display_text_placeholder: 'Enter text…',
    url_text: 'Link',
    url_text_placeholder: 'Enter a URL',

    // check mail weight
    check_mail_weight_title: 'Email exceeds the size limit (20 MB)',
    check_mail_weight_content: 'Reduce the size of your content and try again.',
    check_mail_weight_btn: 'OK',

    //check image size
    check_image_size_title: 'Image exceeds the size limit (0.5 MB)',
    check_image_size_content: 'Reduce the size of image <P1> and try again.',

    // footer sidebar button
    add: 'Add',

    // email dialog footer button
    cancel: 'Cancel',
    save: 'Save',

    // go back dialog
    go_back_dialog_title: 'Before you leave',
    go_back_dialog_content: 'Exit without saving your changes?',
    go_back_dialog_secondary_btn: 'Back',
    go_back_dialog_primary_btn: 'Exit',

    // email editor
    subject_placeholder: 'Add a subject',
    emailSubject: 'Subject',

    // toolbar
    reduce: 'Decrease font size',
    enlarge: 'Increase font size',
    color_picker: 'Font color',
    cut: 'Cut (Ctrl+X)',
    copy: 'Copy (Ctrl+C)',
    paste: 'Paste (Ctrl+V)',
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underline',
    strikethrough: 'Strikethrough',
    align_left: 'Align left',
    align_center: 'Center',
    align_right: 'Align right',
    left_indentation: 'Decrease indent',
    right_indentation: 'Increase indent',
    bulleted_list: 'Create a bulleted list',
    numbered_list: 'Create a numbered list',
    divider: 'Add horizontal line',
    emoji: 'Add emoji',

    // new edit email template message
    edit_new_email_message_title: 'New Email Editor',
    edit_new_email_message_content:
        'Your email will now open in the new Email Editor. \n\n Make sure all existing dynamic values (tags) transitioned correctly.',
    edit_new_email_message_button: 'Edit email',
    edit_new_email_message_cancel: 'Cancel',

    // new email template
    email_subject_label: 'Subject:',
    email_subject_placeholder: 'Email subject will appear here',
    email_edit_mail_button: 'Edit email',
    email_preview_button: 'Preview'
};

export const he = {
    // title
    email_editor: 'עורך אימיילים',

    // dynamic button
    add_dynamic_value_title: 'הוספת ערך דינמי',
    add_dynamic_value_tooltip: 'הוספת ערך דינמי',
    rule_number: 'מספר חוק',
    rule_description: 'תיאור חוק',
    tree_dropdown_label: 'שדה לערך דינמי',
    tree_dropdown_placeholder: 'בחרו שדה מהמסך המתאים',
    tree_dropdown_search_placeholder: 'התחילו לחפש…',
    choose_dropdown_label: 'שדות לערכים דינמיים',
    choose_dropdown_placeholder: 'בחרו שדה',
    choose_dropdown_search_placeholder: 'התחילו לחפש…',

    // image button
    add_an_image: 'הוספת תמונה',
    image_title: 'הוספת תמונה',
    drag_and_drop: 'אפשר לגרור תמונה ישירות אל גוף האימייל או ללחוץ על הכפתור ולבחור תמונה.',
    select_file: 'הוספת קובץ',

    // hyperlink button
    add_hyperlink_tooltip: 'הוספת קישור',
    display_text: 'שם להצגה',
    display_text_placeholder: 'רשמו שם להצגה',
    url_text: 'קישור',
    url_text_placeholder: 'כתובת URL',

    // check mail weight
    check_mail_weight_title: 'גודל האימייל חורג מהמגבלה המותרת (20 MB)',
    check_mail_weight_content: 'צמצמו את גודל התמונה או תוכן אחר שהוספתם לאימייל.',
    check_mail_weight_btn: 'אישור',

    // check image size
    check_image_size_title: 'גודל התמונה חורג מהמגבלה המותרת (0.5 MB)',
    check_image_size_content: 'צמצמו את גודל התמונה <P1> שהוספתם לאימייל.',

    // footer sidebar button
    add: 'הוספה',

    // email dialog footer button
    cancel: 'ביטול',
    save: 'שמירה',

    // go back dialog
    go_back_dialog_title: 'רגע לפני היציאה',
    go_back_dialog_content: 'האימייל עדיין לא נשמר. לצאת בכל זאת?',
    go_back_dialog_secondary_btn: 'חזרה',
    go_back_dialog_primary_btn: 'אישור',

    // email editor
    subject_placeholder: 'נושא ההודעה',
    emailSubject: 'נושא',

    // toolbar
    reduce: 'הקטנת גופן',
    enlarge: 'הגדלת גופן',
    color_picker: 'צבע גופן',
    cut: 'גזירה (Ctrl+X)',
    copy: 'העתקה (Ctrl+C)',
    paste: 'הדבקה (Ctrl+V)',
    bold: 'הדגשה',
    italic: 'הטיה',
    underline: 'קו תחתון',
    strikethrough: 'קו חוצה',
    align_left: 'הצמדה לשמאל',
    align_center: 'למרכז',
    align_right: 'הצמדה לימין',
    left_indentation: 'הקטנת כניסה',
    right_indentation: 'הגדלת כניסה',
    bulleted_list: 'יצירת רשימה עם בולטים',
    numbered_list: 'יצירת רשימה ממוספרת',
    divider: 'הוספת קו אופקי',
    emoji: 'הוספת אימוג׳י',

    // new edit email template message
    edit_new_email_message_title: 'עברנו לעורך אימיילים חדש',
    edit_new_email_message_content:
        'האימייל יפתח עכשיו בעורך האימיילים החדש. \n\n בדקו שתגיות קיימות עברו לעורך החדש בצורה תקינה.',
    edit_new_email_message_button: 'עריכת אימייל',
    edit_new_email_message_cancel: 'ביטול',

    // new email template
    email_subject_label: 'נושא:',
    email_subject_placeholder: 'נושא האימייל יופיע כאן',
    email_edit_mail_button: 'עריכת אימייל',
    email_preview_button: 'תצוגה מקדימה'
};

export const mapping = {
    1: 'email_editor',
    2: 'add_dynamic_value_tooltip',
    3: 'add_an_image',
    4: 'add_hyperlink_tooltip',
    5: 'emailSubject',
    6: 'subject_placeholder',
    7: 'rule_number',
    8: 'rule_description',
    10: 'add',
    11: 'image_title',
    13: 'select_file',
    14: 'add_hyperlink_title',
    15: 'display_text',
    16: 'url_text',
    17: 'check_mail_weight_title',
    18: 'check_mail_weight_content',
    19: 'check_mail_weight_btn',
    20: 'save',
    21: 'cancel',
    22: 'go_back_dialog_title',
    23: 'go_back_dialog_content',
    24: 'go_back_dialog_secondary_btn',
    25: 'go_back_dialog_primary_btn',
    26: 'reduce',
    27: 'enlarge',
    28: 'color_picker',
    29: 'cut',
    30: 'copy',
    31: 'paste',
    32: 'bold',
    33: 'italic',
    34: 'underline',
    35: 'strikethrough',
    36: 'align_left',
    37: 'align_center',
    38: 'align_right',
    39: 'left_indentation',
    40: 'right_indentation',
    41: 'bulleted_list',
    42: 'numbered_list',
    43: 'divider',
    44: 'emoji',
    47: 'add_dynamic_value_title',
    50: 'tree_dropdown_search_placeholder',
    51: 'choose_dropdown_label',
    52: 'choose_dropdown_placeholder',
    53: 'choose_dropdown_search_placeholder',
    54: 'display_text_placeholder',
    55: 'url_text_placeholder',
    56: 'drag_and_drop',
    57: 'email_subject_label',
    58: 'email_subject_placeholder',
    59: 'email_edit_mail_button',
    60: 'email_preview_button',
    64: 'edit_new_email_message_title',
    65: 'edit_new_email_message_content',
    66: 'edit_new_email_message_button',
    67: 'tree_dropdown_label',
    68: 'tree_dropdown_placeholder',
    69: 'edit_new_email_message_cancel',
    70: 'check_image_size_title',
    71: 'check_image_size_content'
};

const fallbacks = {
    en,
    he
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks according to the user's locale
initTexts(entity, fallbacks);

export const texts: typeof en = localization[entity];
